import { render, staticRenderFns } from "./MirrorActivityDetail.vue?vue&type=template&id=65f55887&scoped=true&"
import script from "./MirrorActivityDetail.vue?vue&type=script&lang=js&"
export * from "./MirrorActivityDetail.vue?vue&type=script&lang=js&"
import style0 from "./MirrorActivityDetail.vue?vue&type=style&index=0&id=65f55887&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f55887",
  null
  
)

export default component.exports